import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Typography, Form, InputNumber, Card, Button, Tooltip,} from 'antd';
import { SaveOutlined} from '@ant-design/icons';

import { cardHeaderStyle } from '../util/Style';

const { Title, Text } = Typography;

class PriceControl extends Component {

    formRef = React.createRef();

    constructor(props) {
        super(props);
        this.props = props;
        this.store = props.store;
    }

    componentDidMount() {
        const labPrice = this.props.labPrice;
        const selfPrice = this.props.selfPrice;
        this.formRef.current && this.formRef.current.setFieldsValue({ labPrice, selfPrice});
    }

    render(){
        return (
            <Card key="price_preference" headStyle={cardHeaderStyle} style={{height:"100%"}} title={<Title level={5}>Preferred Price</Title>} >
                <Form layout="vertical" ref={this.formRef} onFinish={this.onFinish} >

                    <Form.Item name="labPrice"
                        rules={[{ required: true, message: 'Please provide the default lab price' }]}
                        label="Price For Lab">
                        <InputNumber />
                    </Form.Item>

                    <Form.Item name="selfPrice"
                        rules={[{ required: true, message: 'Please provide the default Walk-in member Price' }]}
                        label="Price for Self or Walk-in Member">
                        <InputNumber />
                    </Form.Item>

                    <Form.Item>
                        <Tooltip title="To save the preferred price and the selective prices, please press this Apply Price Button.">
                            <Button type="primary" htmlType="submit" disabled={this.store.isLoading} icon={<SaveOutlined />}>Apply Price</Button>
                        </Tooltip>
                    </Form.Item>

                    <Text>This Preferred Price will be applied where the selective prices are zero</Text>
                </Form>
            </Card>
        )
    }

    onFinish = async (values) => {
        await this.store.save(values);
        this.props.refreshPriceGrid();
    }
 }

export default observer(PriceControl);